import { render, staticRenderFns } from "./ReportCards.vue?vue&type=template&id=0897b77b&lang=html&"
import script from "./ReportCards.vue?vue&type=script&lang=js&"
export * from "./ReportCards.vue?vue&type=script&lang=js&"
import style0 from "./ReportCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports